import _ from "lodash";

import { initialState } from "app/store/InitialState";
import * as actions from "./Actions";

export function invoices(state = initialState.invoices, action) {
  let clone = _.cloneDeep(state);
  switch (action.type) {
    case actions.GETTING_OFFICES:
      clone.gettingOffices = action.payload;
      return clone;
    case actions.FETCH_OFFICES:
      clone.offices = action.payload;
      return clone;
    case actions.SELECT_OFFICE:
      clone.selectedOffice = action.payload;
      return clone;
    case actions.GETTING_ASSIGNMENT_MANAGER_LIST:
      clone.gettingAssignmentManagerList = action.payload;
      return clone;
    case actions.SET_ASSIGNMENT_MANAGER_LIST:
      clone.assignmentManagerList = action.payload;
      return clone;
    case actions.ASSIGNMENT_MANAGER_SELECTED:
      clone.selectedAssignmentManager = action.payload;
      return clone;
    case actions.SELECT_ASSIGNMENT_MANAGER:
      if (!action.payload) {
        clone.selectedAssignmentManager = "";
      } else {
        clone.selectedAssignmentManager = action.payload.name;
      }
      return clone;
    case actions.GETTING_COMMITMENTS:
      clone.gettingCommitments = action.payload;
      return clone;
    case actions.ASSIGNMENT_MANAGER_GET_COMMITMENTS:
      clone.commitments = action.payload;
      return clone;
    case actions.IS_REMOVING:
      clone.isRemoving = action.payload;
      return clone;
    case actions.REMOVE_COMMITMENT:
      clone.commitments.splice(
        clone.commitments.findIndex((x) => x.id === action.payload.id),
        1
      );
      return clone;
    case actions.EMPTY_COMMITMENTS:
      clone.commitments = [];
      return clone;
    case actions.GETTING_RESULTS:
      clone.gettingResultStatistics = action.payload;
      return clone;
    case actions.SET_RESULTS:
      clone.resultStatistics = action.payload;
      return clone;
    case actions.REMOVE_RESULTS:
      clone.resultStatistics = {};
      return clone;
    case actions.CHANGE_MODE:
      clone.mode = action.payload;
      return clone;
    default:
      return state;
  }
}
